__turbopack_context__.v({
  "card": "_4OIvKq_card",
  "cards": "_4OIvKq_cards",
  "content": "_4OIvKq_content",
  "descriptionCategory": "_4OIvKq_descriptionCategory",
  "gridContainer": "_4OIvKq_gridContainer",
  "gridItem": "_4OIvKq_gridItem",
  "headContact": "_4OIvKq_headContact",
  "p": "_4OIvKq_p",
  "p1": "_4OIvKq_p1",
  "page-body-wrap": "_4OIvKq_page-body-wrap",
  "paragraph": "_4OIvKq_paragraph",
  "paragraph-content": "_4OIvKq_paragraph-content",
  "slider": "_4OIvKq_slider",
  "t": "_4OIvKq_t",
  "tabs": "_4OIvKq_tabs",
  "tabsGroup": "_4OIvKq_tabsGroup",
  "title": "_4OIvKq_title",
  "wrap-container": "_4OIvKq_wrap-container",
  "wrap-content": "_4OIvKq_wrap-content",
});
